import {
  CREATE_EQUIPMENT_SUB_TYPE_SUCCESS,
  FETCH_EQUIPMENT_SUB_TYPE_SUCCESS,
  GET_EQUIPMENT_SUB_TYPE_SUCCESS,
  REFRESH_EQUIPMENT_SUB_TYPE_DATA,
  SAVE_EQUIPMENT_SUB_TYPE_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_EQUIPMENT_SUB_TYPE_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_EQUIPMENT_SUB_TYPE_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_EQUIPMENT_SUB_TYPE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_EQUIPMENT_SUB_TYPE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case REFRESH_EQUIPMENT_SUB_TYPE_DATA: {
      return {
        ...state,
        edit: {},
      }
    }


    default:
      return state;
  }
}
